export const backgroundColor = {
  black: "#262626",
  green: "#3f9d2f",
  gray: "#c6c6c6",
};

export const ratingColor = {
  red: "#F93324",
  green: "#1181f2",
  yellow: "#f28500",
  grey: "#e2e2e2",
};
export const X_API_KEY = "5RrMUWapkS6yk6UxFRb2n4kO4Nca6qHj4CgFzYDb";
